import React, { ReactElement, useState } from "react";
import { Subject } from "rxjs";
import { debounceTime, distinctUntilChanged } from "rxjs/operators";
import cx from "classnames";
type State = string;
type OnButtonValueChange = (name: string, value: State) => void;

const DropdownSearch = ({
	children,
	placeholder,
	title,
	isOpen = false,
	onClick,
	value,
}: {
	children: ReactElement;
	title: string;
	placeholder: string;
	isOpen?: boolean;
	onClick?;
	value?;
}) => {
	const [state, setState] = useState(value);

	const getSelectedValuesLabels = () => {
		if (isDefaultState()) {
			return placeholder;
		}

		return state;
	};

	const isDefaultState = (): boolean => {
		return !state;
	};

	const className = cx("filterAttribute", {
		open: isOpen,
		closed: !isOpen,
		active: !isDefaultState(),
	});
	return (
		<div className={className}>
			<div className="filterValue" onClick={onClick}>
				{getSelectedValuesLabels()}
			</div>
			<div className="filterOptions filterSearch">
				<h6>{title}</h6>
				<div className="field searchField searchFieldWithIcon">
					{children}
				</div>
			</div>
		</div>
	);
};

export default DropdownSearch;
